import React from 'react';

const loginReminder = (props) => {
  if (!props.isLoggedIn) {
    return (
      <p className="login_reminder">
        You can play the crossword as a guest, but you need to <a href="/users/sign_up">register</a> and <a href="/users/sign_in">log in</a> to see the solution.
      </p>
    );
  } else {
    return null;
  }
};

export default loginReminder;
